<template>
    <div class="w-100">
        <div class="mt-1" >
            <v-row class="no-frame">
                <v-col class="no-frame pr-2" :class="colWidth[0]">
                    <p-dms-treeview
                        :title     = "unit.fabricNo"
                        :folder   = "folders"
                        :border   = "true"
                        :height   = "height"
                        @selected = "onDocument"
                    />
                </v-col>
                <v-col class="no-frame" :class="colWidth[1]">
                    <c-column-header
                        v-if   = "selected"
                        :label = "selected.name"
                        class  = "primary"
                    >
                    </c-column-header>
                    <c-dms-viewer
                        v-if      = "selected"
                        :document = "document"
                        :border   = "false"
                        class     = "w-100 white mt-1"
                        style     = "height: calc(100% - 35px)"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import Dms            from "@/modules/dms/common/service/Dms";
import CColumnHeader  from "@/modules/core/components/utils/CColumnHeader.vue";
import CDmsViewer     from "@/modules/dms/viewer/CDmsViewer.vue";
import PDmsTreeview   from "@/modules/dms/treeview/components/private/PDmsTreeview.vue";

export default {
    name: "CDmsTreeviewUnit",

    components: {
        PDmsTreeview,
        CDmsViewer,
        CColumnHeader,
    },

    props: {
        unit: {
            required: true,
            type    : Object,
            default : function () {
                return {
                }
            },
        },

        colWidth: {
            required: false,
            type: Array,
            default: () => {
                return [
                    "col-6",
                    "col-6"
                ]
            }
        },


        height: {

        }

    },

    data: () => ({
        selected   : null,
        dmsSite: null,
        na     : "---",
        mailContent: null,
        docname: null,
        openRename: false,
        document: null
    }),

    computed: {
        folders () {
            if (!this.dmsSite || !this.dmsSite.folder) {
                return [];
            }

            return this.dmsSite.folder.entries.slice ().sort ((l,r) => l.name.localeCompare(r.name));
        },
    },

    mounted() {
        this.load();
    },

    watch: {
        unit () {
            this.load();
        }
    },

    methods: {
        load () {
            if (!this.unit.id) {
                return;
            }

            Dms.site(this.unit.id, (data) => {
                this.dmsSite = data;
            });
        },

        onDocument (document) {
            if (this.selected && document && this.selected.id === document.id) {
                this.selected = null;
                this.document = null;
                Core.fire.selected(this, null);
                return;
            }

            this.selected = document;
            if (document) {
                this.$nextTick(() => {
                    this.document = document.id
                });
            }

            Core.fire.selected(this, this.selected);
        },
    }
}
</script>

<style scoped>

</style>